import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Parvus Sed Potens",
  date: new Date(2024, 0, 22),
  img: "/img/ice-ogre.jpeg",
  tracks: [
    {
      title: "Chrissyfit Redux",
      src: "/songs/2024-01-22/chrissyfit_redux.mp3",
      duration: 994.416,
    },
    {
      title: "Reimagination",
      src: "/songs/2024-01-22/reimagination.mp3",
      duration: 864.936,
    },
    {
      title: "What's The Deal With Music?!",
      src: "/songs/2024-01-22/whats_the_deal_with_music.mp3",
      duration: 1165.512,
    },
    {
      title: "Petri Dish",
      src: "/songs/2024-01-22/petri_dish.mp3",
      duration: 786.168,
    },
    {
      title: "Boulders In The River",
      src: "/songs/2024-01-22/boulders_in_the_river.mp3",
      duration: 698.4,
    },
    {
      title: "Ötzi The Iceman",
      src: "/songs/2024-01-22/otzi_the_iceman.mp3",
      duration: 1001.376,
    },
    {
      title: "Culmination",
      src: "/songs/2024-01-22/culmination.mp3",
      duration: 1394.304,
    },
  ],
};
export default album;
